import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';
import { uiReducer, xmlDataReducer, jsonEditorReducer, reactFlowWatchers, uiWatchers } from './store';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import LogRocket from 'logrocket';

function* appSaga() {
  yield all([...reactFlowWatchers, ...uiWatchers]);
}

export const history = createBrowserHistory();

export const setupStore = () => {
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    reducer: {
      ui: uiReducer,
      xmlData: xmlDataReducer,
      jsonEditor: jsonEditorReducer,
      router: connectRouter(history) as any,
    },
    middleware: [sagaMiddleware, routerMiddleware(history), LogRocket.reduxMiddleware()],
    devTools: true,
  });

  sagaMiddleware.run(appSaga);

  return store;
};
